export default "__VITE_ASSET__BhEPlmRA__"